module.exports = __webpack_public_path__ + "static/media/bg.52db4fc7.png";